/**
 * Helper
 */
var helper = require('../../helper');

function TicketOfMemberDataTable() {
    this.dataTables_buttons = [
	    {
		    extend: 'csv',
		    text: 'Export as CSV',
		    exportOptions: {
			    columns: '.data-export'
		    },
	    },
	    {
		    extend: 'pdf',
		    text: 'Export as PDF',
		    exportOptions: {
			    columns: '.data-export'
		    },
		    orientation: 'landscape'
	    },
	    {
		    extend: 'print',
		    text: 'Print table',
		    exportOptions: {
			    columns: '.data-export'
		    }
	    },
	    {
		    extend: 'colvis'
	    }

    ];

    this.$field = $('#datatable-tickets-of-member');
    this.userId =  this.$field.data('user');
    this.$overviewBox = $('.js-ticket-activity-box');

    this.table = this.$field.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": this.dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100, -1], [ 30, 10, 25, 50, 75, 100, "All"]],
        "ajax": {
            "url": helper.getOrigin() + "/api/tickets/member-dt/" + this.userId,
            "method": 'POST',
            "data": function ( d ) {
                d.status_id = $('input[name="clickedStatusId"]').val();
            }
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": [
	        {data: 'ticketId', name: 'tickets.id', className: 'data-export'},
	        {data: 'status', name: 'statusName', className: 'data-export'},
	        {data: 'urgency', name: 'tickets_urgency.name', className: 'data-export'},
	        {data: 'property_id', name: 'propertyPublicId', visible: false, className: 'data-export'},
	        {data: 'property_name', name: 'propertyName', className: 'data-export'},
	        {data: 'postcode', name: 'properties.postcode', className: 'data-export'},
	        {data: 'created_at', name: 'tickets.created_at', className: 'data-export'},
	        {data: 'book_in_date', name: 'tickets.book_in_date', className: 'data-export'},
	        {data: 'date_estimated_completion', name: 'tickets.date_estimated_completion', className: 'data-export'},
	        {data: 'date_completed', name: 'tickets.date_completed'},
	        {data: 'job_type', name: 'serviceName', className: 'data-export'},
	        {data: 'client_view', name: 'tickets.client_view', className: "centerize"},
	        {data: 'guardian_view', name: 'tickets.guardian_view', className: "centerize"},
	        {data: 'contact_first_name', name: 'users.first_name', visible: false, className: 'data-export'},
	        {data: 'contact_last_name', name: 'users.last_name', visible: false, className: 'data-export'},
	        {data: 'contractor', name: 'contractorName', className: 'data-export'},
	        {data: 'cost_of_works', name: 'tickets.cost_of_works', visible: false, className: 'data-export'},
	        {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action hidden-print"}
        ],
	    'columnDefs': [
		    {
			    'targets': 11,
			    'searchable':true,
			    'orderable':false,
			    'className': 'dt-body-center tiny-column',
			    'render': function (data, type, full, meta){

				    if (data[0] == 1) { // if field in database is 1 (checked)
					    return '<input id="client_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="client_view[]" value="1" checked>';
				    } else {
					    return '<input id="client_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="client_view[]" value="0">';
				    }

			    }
		    },
		    {
			    'targets': 12,
			    'searchable':true,
			    'orderable':false,
			    'className': 'dt-body-center tiny-column',
			    'render': function (data, type, full, meta){

				    if (data[0] == 1) { // if field in database is 1 (checked)
					    return '<input id="guardian_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="guardian_view[]" value="1" checked>';
				    } else {
					    return '<input id="guardian_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="guardian_view[]" value="0">';
				    }

			    }
		    }
	    ]
    });

    var self = this;

    this.$overviewBox.on('click', function() {
        var $this = $(this),
            $clickedStatusId = $('input[name="clickedStatusId"]'),
            statusId = $(this).data('status_id');

        $clickedStatusId.val( statusId );

        console.log('click status!');
        console.log( statusId);

        self.table.ajax.reload();
    });

}

TicketOfMemberDataTable.prototype.reload = function() {
    var self = this;
    self.table.ajax.reload();
}

module.exports = TicketOfMemberDataTable;
